export default __webpack_public_path__ + "static/platform-ai-workflows-b65ccea44aff9eb58c0fe97ba1016ea5.png";